<template>
  <div :class="$style.container">
    <div :class="$style.content">

      <div v-if="$slots.hasOwnProperty('overlay')" :class="$style.overlay">
        <slot name="overlay" />
      </div>

      <div :class="$style.poster">
        <slot name="poster" />
      </div>

      <div :class="$style.form">
        <div :class="$style.logoMobile">
          <logo-medium />
        </div>

        <slot name="default" />

        <div v-if="$slots.hasOwnProperty('information')" :class="$style.informationMobile">
          <slot name="information" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LogoMedium from 'atoms/logos/LogoMedium';

export default {
  name: 'AuthTemplate',
  components: {
    LogoMedium,
  },
};
</script>

<style lang="sass" module>
  .container
    width: 100%
    min-height: 100vh
    position: relative
    padding: 40px 20px
    overflow: hidden

    +respond-to('medium')
      display: flex
      align-items: center
      padding: 0

  .content
    margin: 0 auto
    display: flex

  .overlay
    width: 100%
    height: 100%
    overflow: hidden
    position: absolute
    top: 0
    left: 0
    z-index: -1

  .poster
    display: none

    +respond-to('medium')
      display: flex
      align-items: center

  .form
    width: 100%
    max-width: 460px
    margin: 0 auto
    position: relative

    +respond-to('medium')
      width: 460px
      margin-left: 90px

  .logoMobile
    text-align: center
    margin-bottom: 44px

    +respond-to('medium')
      display: none

  .informationMobile
    display: block

    +respond-to('medium')
      display: none

    p
      font-weight: 500
      font-size: 14px
      line-height: 18px
      color: #fff
      opacity: .75

      &:not(:last-child)
        margin: 0 0 20px
</style>
